var jQuery = require('jquery');
window.jQuery = jQuery;
window.$ = jQuery;

require('moment');
require('bootstrap/js/dist/alert');
require('bootstrap/js/dist/button');
require('bootstrap/js/dist/collapse');
require('bootstrap/js/dist/dropdown');
require('bootstrap/js/dist/modal');
// require('bootstrap/js/dist/popover');
// require('bootstrap/js/dist/scrollspy');
require('bootstrap/js/dist/tab');
require('bootstrap/js/dist/tooltip');
require('bootstrap/js/dist/util');

require('bootstrap-select');
// require('pc-bootstrap4-datetimepicker');

require( "jquery-ui/ui/widgets/draggable");

require('jquery.are-you-sure');
require('webticker/jquery.webticker.js');

// DOM Ready functions using custom async function so it only funs when jQuery has been fully loaded
$(function() {

    // Initialise the Ajax functions - put most of your js calls in this function
    // or if you need to reload them after an ajax call
    // initAjaxJS();

    // $(window).load(function() {
    // });

    // Universal Analytics event tracking
    if (typeof ga !== 'undefined') {

        // track all phone number click events
        $('a[href^="tel:"]').on('click', function(e) {
            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Phone', 'click', value[1]);
        });

        // track all email click events
        $('a[href^="mailto:"]').on('click', function(e) {

            var href = $(this).attr('href');
            var value = href.split(':');

            // console.log('clicked', $(this).text(), value[1]);
            ga('send', 'event', 'Email', 'click', value[1]);
        });

    }

    $('.selectpicker-fc').selectpicker({
        style: '',
        styleBase: 'form-control',
    });

    // Off canvas mobile nav
    $('[data-toggle="offcanvas"]').on('click',function() {
        $('.offcanvas').toggleClass('active');
        $(this).toggleClass('active');

        if($(this).hasClass('active')){
            $(this).find('.icon').text('close');
        }else{
            $(this).find('.icon').text('menu');
        }

    });

    // $('.scrollup').click(function() {
    //     $("html, body").animate({
    //         scrollTop: 0
    //     }, 600);
    //     return false;
    // });

    // $(window).scroll(function () {
    //     if ($(this).scrollTop() > 200) {
    //         $('#page-top').fadeIn();
    //     } else {
    //         $('#page-top').fadeOut();
    //     }

    // });


    //tabbed url
    if (location.hash.substr(0, 2) == "#!") {
        $("a[href='#" + location.hash.substr(2) + "']").tab("show");
    }

    $("a[data-toggle='tab']").on("shown.bs.tab", function(e) {
        var hash = $(e.target).attr("href");
        if (hash.substr(0, 1) == "#") {
            location.replace("#!" + hash.substr(1));
        }
    });

    // Search Filters Datepicker
    // Using font-awesome 5 icons
    // $.extend(true, $.fn.datetimepicker.defaults, {
    //     icons: {
    //       time: 'far fa-clock',
    //       date: 'far fa-calendar',
    //       up: 'fas fa-arrow-up',
    //       down: 'fas fa-arrow-down',
    //       previous: 'fas fa-chevron-left',
    //       next: 'fas fa-chevron-right',
    //       today: 'far fa-calendar-check',
    //       clear: 'far fa-calendar-times',
    //       close: 'far fa-times-circle'
    //     }
    // });
    // $('.datepicker').datetimepicker({
    //     format: 'DD/MM/YYYY',
    //     showTodayButton: true,
    //     showClear: true
    // });
    // $('.datepicker-start').datetimepicker({
    //     format: 'DD/MM/YYYY',
    //     showTodayButton: true,
    //     showClear: true
    // });
    // $('.datepicker-end').datetimepicker({
    //     format: 'DD/MM/YYYY',
    //     showTodayButton: true,
    //     showClear: true,
    //     useCurrent: false //Important! See issue #1075
    // });

    // $('.datepicker-start').on("dp.change", function (e) {
    //     $('.datepicker-end').data('DateTimePicker').minDate(e.date);
    // });
    // $('.datepicker-end').on("dp.change", function (e) {
    //     $('.datepicker-start').data('DateTimePicker').maxDate(e.date);
    // });

    $('.reset-filter').on('click', function(e){
        e.preventDefault();
        $(this).closest('form').find('input[type=text]').val('');
    });


    $('[data-toggle="tooltip"]').tooltip();

    // Notifications Ticker
    if ($('#notifications').length) {
        var tickerSpeed = $("#webTicker").attr("data-speed");

        $(window).on('load resize', function(e){
            var navWidth =  $('#header-nav').outerWidth();
            if($(window).width() > 992){
                $('.ticker-wrap').css('right', (navWidth) + 'px');
                $('#wrapper').addClass('h-100');

                if(e.type == 'load'){
                    $('#webTicker').webTicker({
                        speed:tickerSpeed,
                        duplicate: true,
                        startEmpty: false,
                        height: '72px'
                    });
                } else{

                }

            }else{
                $('.ticker-wrap').removeAttr('style');
                $('#wrapper').removeClass('h-100');

                if(e.type == 'load'){
                    $('#webTicker').webTicker({
                        speed: tickerSpeed,
                        duplicate: true,
                        startEmpty: false,
                        height: '48px'
                    });
                } else{
                    // $('.tickercontainer').css('position','absolute');
                }
            }
            // notifications alert
        });
    };

});

//-----------------------------------------------
// Global AJAX / Application Functions
//-----------------------------------------------
function initAjaxJS() {


}

var placeSearch, autocomplete;
var componentForm = {
    '#street': ['street_number', 'route'],
    '#suburb': ['locality'],
    '#city': ['administrative_area_level_1'],
    '#country': ['country'],
    '#postcode': ['postal_code'],
};

function getAddressComponents(componentTypes) {
    var place = autocomplete.getPlace();

    // Get each component of the address from the place details
    // and fill the corresponding field on the form.
    var results = [];
    for (var i = 0; i < place.address_components.length; i++) {
        var addressType = place.address_components[i].types[0];
        if (componentTypes.includes(addressType)) {
            var val = place.address_components[i].long_name;
            results.push(val);
        }
    }
    return results;
}

function fillInAddress() {
    // Get the place details from the autocomplete object.

    for (var component in componentForm) {
        var addressComponents = getAddressComponents(componentForm[component]);
        $(component).val(addressComponents.join(' '));
    }
}

function initAutocomplete () {
    $('input[data-gmap="autocomplete"]').each(function (idx, input) {
        autocomplete = new google.maps.places.Autocomplete(
            /** @type {!HTMLInputElement} */ input,
            { types: ['geocode'], componentRestrictions: { country: 'NZ' } }
        );
        // When the user selects an address from the dropdown, populate the address
        // fields in the form.
        autocomplete.addListener('place_changed', fillInAddress);
    });

}
function initSelectpickers(classname = '.selectpicker-fc'){
    $(classname).selectpicker({
        style: '',
        styleBase: 'form-control',
        selectAllText: 'All',
        deselectAllText: 'None',
    });
}
window.initAutocomplete = initAutocomplete;
window.initSelectpickers = initSelectpickers;